import { useSettings } from "@/context/SettingsContext";
import { BlurInput, ColorInput, Pick, Row, Section, Toggle } from "@/components/settings/Controls";

const AGENTS = [{ ext: "201", name: "Josh" }, { ext: "210", name: "Taya" }, { ext: "203", name: "Ollie" }, { ext: "202", name: "Kyle" }];
const JOKES = [{ value: "dad_joke", label: "Dad joke" }, { value: "quote", label: "Motivational quote" }, { value: "fact", label: "Fun fact" }];
const HOURS = Array.from({ length: 24 }, (_, h) => ({ value: h, label: `${String(h).padStart(2, "0")}:00` }));

export const WallboardTab = () => {
  const { team, saveTeam } = useSettings();
  if (!team) return null;
  const w = team.wallboard;
  const set = (patch) => saveTeam({ wallboard: patch }, "Wallboard updated");
  const target = (ext, key, v) => set({ targets: { [ext]: { [key]: Math.max(0, Number(v) || 0) } } });
  return (
    <div className="space-y-6">
      <Section title="Daily call targets" hint="Each agent's target for the day. The TV shows progress against it." testid="settings-targets">
        {AGENTS.map((a) => (
          <Row key={a.ext} label={a.name} hint={`Extension ${a.ext}`}>
            <BlurInput type="number" min={0} value={w.targets[a.ext]?.calls} onSave={(v) => target(a.ext, "calls", v)} className="w-20 font-mono" testid={`target-calls-${a.ext}`} />
            <span className="text-xs text-muted-foreground">calls</span>
            <BlurInput type="number" min={0} value={w.targets[a.ext]?.talk_minutes} onSave={(v) => target(a.ext, "talk_minutes", v)} className="w-20 font-mono" testid={`target-talk-${a.ext}`} />
            <span className="text-xs text-muted-foreground">talk mins</span>
          </Row>
        ))}
      </Section>
      <Section title="Behind-target alerts" testid="settings-behind">
        <Toggle label="Judge by pace through the day" hint="On: behind means below where they should be by now (9am to 5pm). Off: only compared with the full-day target." checked={w.pace_mode} onChange={(v) => set({ pace_mode: v })} testid="wb-pace-mode" />
        <Row label="Colour when behind"><ColorInput value={w.behind_color} onSave={(v) => set({ behind_color: v })} testid="wb-behind-color" /></Row>
        <Row label="Colour when on track or ahead"><ColorInput value={w.ahead_color} onSave={(v) => set({ ahead_color: v })} testid="wb-ahead-color" /></Row>
        <Toggle label="Flash the card when behind" checked={w.behind_flash} onChange={(v) => set({ behind_flash: v })} testid="wb-behind-flash" />
      </Section>
      <Section title="Display" testid="settings-display">
        <Toggle label="Spin the Atom logo" checked={w.logo_spin} onChange={(v) => set({ logo_spin: v })} testid="wb-logo-spin" />
        <Toggle label="Night mode after hours" hint="Dims the TV outside the hours below." checked={w.night_mode} onChange={(v) => set({ night_mode: v })} testid="wb-night-mode" />
        <Row label="Night mode from / to">
          <Pick value={w.night_from} onChange={(v) => set({ night_from: Number(v) })} options={HOURS} className="w-28" testid="wb-night-from" />
          <Pick value={w.night_to} onChange={(v) => set({ night_to: Number(v) })} options={HOURS} className="w-28" testid="wb-night-to" />
        </Row>
        <Toggle label="Office weather" checked={w.weather} onChange={(v) => set({ weather: v })} testid="wb-weather" />
        <Row label="Weather city"><BlurInput value={w.weather_city} onSave={(v) => v.trim() && set({ weather_city: v.trim() })} testid="wb-weather-city" /></Row>
        <Toggle label="Joke / quote of the day" checked={w.joke} onChange={(v) => set({ joke: v })} testid="wb-joke" />
        <Row label="What kind"><Pick value={w.joke_kind} onChange={(v) => set({ joke_kind: v })} options={JOKES} testid="wb-joke-kind" /></Row>
      </Section>
    </div>
  );
};
